<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"><path d="M12.5 2.344A10.155 10.155 0 0 0 2.344 12.5v3.125H0V12.5a12.5 12.5 0 0 1 25 0v11.333h-9.372V25h-3.909a2.344 2.344 0 0 1 0-4.687h3.906v1.172h7.031V12.5A10.155 10.155 0 0 0 12.5 2.344zm-3.125 8.594v7.812H3.906v-7.812zm11.719 0v7.812h-5.469v-7.812z"/></svg>
</template>

<script>
	export default {
		name: "Headset"
	}
</script>